import { SendToEnum } from '@schemax-whatsapp/shared-models';
import { PrimaryGeneratedColumn, Index, Entity, Column, ManyToOne, JoinColumn, OneToMany, CreateDateColumn, UpdateDateColumn, VersionColumn, Generated } from 'typeorm';

@Entity('excel_import')
export class ExcelImport{
    @PrimaryGeneratedColumn('increment', {
        name: 'excel_import_id'
    })
    excelImportId: number;

    @Column('varchar', {
        nullable: false,
        length:50,
        name: 'member_name',
    })
    memberName: string;

    @Column("varchar",{
        nullable:false,
        length:20,
        name:'phone_number',
    })
    phoneNumber: string;

    @Column("enum",{
        nullable:false,
        enum: SendToEnum,
        default: SendToEnum.Associates,
        name:'ref_type',
    })
    refType: SendToEnum;

    @Column("varchar",{
        nullable:false,
        length:20,
        default: '',
        name:'ref_code',
    })
    refCode: string;

    @Column("varchar",{
        nullable:false,
        length:30,
        default: '',
        name:'department',
    })
    department: string;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column("integer",{
        nullable: false,
        name:'company_id',
    })
    companyId: string;

    @Column("varchar",{
        nullable:false,
        length:30,
        default: '',
        name:'email',
    })
    email: string;
}